/**
 * Koordinaten der Stadt Marburg
 */
export const CITY_COORDINATES = {
  lat: 50.808453,
  lng: 8.771796,
}
